import React from 'react'
import RenderBtn from './RenderBtn';
import { useTranslation } from 'react-i18next';

function UserNavbar() {
  const {t} = useTranslation('global');  
  return (
    <>
         <div>
          <RenderBtn to="/userDashboard"> {t('home')}</RenderBtn>
          </div>
    </>
  )
}

export default UserNavbar